import { render, staticRenderFns } from "./QueryElkI.vue?vue&type=template&id=44480d35&"
import script from "./QueryElkI.vue?vue&type=script&lang=js&"
export * from "./QueryElkI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports